import { Component, Input, OnInit, ViewChild, OnChanges } from '@angular/core';
import { hd } from '@nx-fe/services';

@Component({
  selector: 'xs-collapsible-user-list',
  templateUrl: './collapsible-user-list.component.html',
  styleUrls: ['./collapsible-user-list.component.scss'],
})
export class CollapsibleUserListComponent implements OnInit, OnChanges {
  @ViewChild('userListContainingElement', { static: true }) userListContainingElement;

  @Input()
  public userInfoList: hd.IUserInfoModel[];

  @Input()
  public label: string;

  public userList: hd.IUserInfoModel[];

  /** If user list is cut or not due to length */
  public isTruncated = false;

  /** Is expanded */
  public isExpanded = false;

  /** The user string */
  public usersString = '';

  /** To manage the number of hidden users internally */
  public numberOfHiddenUsers = 0;

  /** To measure width of text */
  private canvas: HTMLCanvasElement;

  /** To manage the list of users name that displays */
  private trimmedUserList: hd.IUserInfoModel[] = [];

  /** To manage hidden users text internally */
  private hiddenUserList = '';

  constructor() {
    this.canvas = document.createElement('canvas');
  }

  /**
   * Called to pass required information during controller initialization.
   */
  public ngOnInit() {
  }

  public ngOnChanges() {
    this.userList = this.formatUserList();
  }

  /** Toggle show or hide full list of user */
  public toggleShowFullUserList = () => {
    this.isExpanded = !this.isExpanded;
  };

  /** Format user list with considering width of screen */
  public formatUserList = (): hd.IUserInfoModel[] => {
    let widthOfMoreLink: number;
    let widthOfPanel: number = this.userListContainingElement.nativeElement.clientWidth;

    widthOfPanel -= 40;

    let localStringToTest = '';
    let widthText = 0;
    const shevronButtonPadding = 10;

    /** Set Font type to calculate pixel size of text */
    let fontType = '';
    fontType += this.userListContainingElement.nativeElement.fontStyle + ' ';
    fontType += this.userListContainingElement.nativeElement.fontWeight + ' ';
    fontType += this.userListContainingElement.nativeElement.fontSize + ' ';
    fontType += this.userListContainingElement.nativeElement.fontFamily;

    this.numberOfHiddenUsers = 0;

    /** To consider space for shveron button, X are appened.
     *  Normally, numeric character has the same width, so 999 is used to calculate
     *  the width of three digit number. Additionaly, we add the button padding
     */

    this.usersString = this.formatUserListWithCommas(this.userInfoList);

    if (!this.isExpanded) {
      this.isTruncated = false;
      this.trimmedUserList = [];
      this.hiddenUserList = '';
      if (this.userInfoList.$resolved || this.userInfoList.length > 0) {
        this.userInfoList.forEach((userInfo, index) => {
          localStringToTest =
            this.formatUserListWithCommas(this.trimmedUserList) + this.hiddenUserList + userInfo.displayName + ', ';
          widthOfMoreLink = this.measureWidthOfText('+ 999 more X', fontType) + shevronButtonPadding;
          widthText = this.measureWidthOfText(localStringToTest, fontType);

          if (!this.isTruncated && this.trimmedUserList.length === 0) {
            this.trimmedUserList.push(userInfo);
          } else if (!this.isTruncated && widthText + widthOfMoreLink <= widthOfPanel) {
            this.trimmedUserList.push(userInfo);
          } else if (!this.isTruncated && widthText <= widthOfPanel && index === this.userInfoList.length) {
            this.trimmedUserList.push(userInfo);
          } else {
            this.isTruncated = true;
            this.numberOfHiddenUsers++;
            this.hiddenUserList += userInfo.displayName + ', ';
          }
        });
      }
    }

    if (this.isExpanded) {
      this.userInfoList.forEach(() => {
        this.trimmedUserList = this.userInfoList;
      });
    }

    return this.trimmedUserList;
  };

  /** Get pixel of text with given element font */
  private measureWidthOfText = (textToMeasure: string, font: any): number => {
    const context: any = this.canvas.getContext('2d');
    context.font = font;

    return Math.floor(context.measureText(textToMeasure).width);
  };

  /** To display string array with commas */
  private formatUserListWithCommas = (userInfo: hd.IUserInfoModel[]): string => {
    let resultText = '';

    userInfo.forEach(element => {
      resultText += ', ' + element.displayName;
    });

    resultText = resultText.substr(2);

    return resultText;
  };
}
